import {
  createRootRouteWithContext,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { AuthContextValue } from "../contexts/AuthContext";
import { NotFound } from "../pages/NotFound/NotFound";

export const Route = createRootRouteWithContext<{ auth: AuthContextValue }>()({
  notFoundComponent: NotFound,
  beforeLoad: ({ context, location }) => {
    if (
      !context.auth.state.loading &&
      !context.auth.state.isLoggedIn &&
      location.pathname !== "/login" &&
      location.pathname !== "/login-link"
    ) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: () => (
    <>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-9999 focus:top-4 focus:left-4 focus:px-4 focus:py-2 focus:bg-primary-500 focus:text-white focus:rounded-lg"
      >
        Skip to main content
      </a>
      <Outlet />
    </>
  ),
});
